import React from 'react';
import { FaDownload } from 'react-icons/fa';
import moment from 'moment';

const DownloadTableData = ({ data, headers, filenamePrefix, showAllView }) => {
  const handleDownload = () => {
    // Create headers without the phone column
    const filteredHeaders = headers.filter(header => header !== "Phone" && header !== "Call");
    
    // Create CSV content
    const csvContent = [
      filteredHeaders.join(','), // Header row
      ...data.map(row => {
        // Remove phone number (index 2) and call column (index 3) from the row
        const rowWithoutPhone = [...row];
        rowWithoutPhone.splice(2, 2); // Remove phone and call columns
        return rowWithoutPhone.map(cell => `"${cell}"`).join(',');
      })
    ].join('\n');

    // Create and download the file
    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `${filenamePrefix}_${moment().format('YYYY-MM-DD')}.csv`;
    document.body.appendChild(a);
    a.click();
    window.URL.revokeObjectURL(url);
    document.body.removeChild(a);
  };

  if (!showAllView) return null;

  return (
    <button
      onClick={handleDownload}
      className="flex items-center gap-2 px-4 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700 transition-colors"
    >
      <FaDownload />
      Download Table Data
    </button>
  );
};

export default DownloadTableData; 